import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from 'environments/environment';
import { AppModule } from 'app/app.module';
import * as Sentry from '@sentry/angular';
import {
    isTokenRoute,
    scrubBreadcrumb,
    scrubEvent,
    scrubTransaction
} from 'app/core/services/observability/sentry-scrubber';
import { createSentryReplay } from 'app/core/services/observability/sentry-replay';
import { flare } from '@flareapp/js';

if (environment.sentryUrl) {
    // A page loaded straight onto a credential URL (share link, password reset) starts without
    // replay: a buffer started here would carry the token in its URL list, and stopping it from the
    // router is too early to take effect. SentryContextService adds replay once the user leaves.
    const landedOnTokenRoute = isTokenRoute(window.location.pathname + window.location.search);

    Sentry.init({
        dsn: environment.sentryUrl,
        release: environment.release.version,
        environment: environment.type,
        integrations: [Sentry.browserTracingIntegration(), ...(landedOnTokenRoute ? [] : [createSentryReplay()])],
        // 'captured as exception with keys' is SDK v8+ wording for a thrown non-Error (e.g. an unhandled
        // HttpErrorResponse); 'Non-Error exception captured' was v7's and no longer matches.
        ignoreErrors: ['Non-Error exception captured', 'captured as exception with keys', 'Http failure'],
        beforeSend: event => scrubEvent(event),
        beforeSendTransaction: event => scrubTransaction(event),
        beforeBreadcrumb: breadcrumb => scrubBreadcrumb(breadcrumb),
        tracesSampleRate: 0.2,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0
    });
}

if (environment.flareKey) {
    flare.light(environment.flareKey);
}

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, {
        applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true })]
    })
    .catch(err => console.error(err));
